import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Bright%20airy%20modern%20workspace%20with%20a%20large%20wooden%20desk%20featuring%20laptop%20showing%20colorful%20analytics%20dashboards%20surrounded%20by%20curated%20product%20samples%20including%20sneakers%20fabric%20swatches%20and%20minimal%20accessories%2C%20warm%20morning%20sunlight%20streaming%20through%20floor%20to%20ceiling%20windows%2C%20lush%20green%20plants%20in%20background%2C%20cream%20and%20warm%20beige%20neutral%20palette%2C%20editorial%20photography%20style%2C%20soft%20natural%20shadows%2C%20aspirational%20atmosphere%2C%20no%20text%20no%20logos%2C%20clean%20modern%20composition&width=1800&height=1000&seq=hero-bg-acbuy-v2&orientation=landscape"
        alt="ACBuySpreadsheet product sourcing showcase"
        title="ACBuySpreadsheet product sourcing spreadsheet system"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-2xl">
            <span className="inline-block text-xs md:text-sm font-medium text-white/80 tracking-widest uppercase mb-4">
              Ecommerce Spreadsheet System
            </span>
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
              ACBuy<br />Spreadsheet<br />Sourcing System
            </h1>
            <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-lg mb-8">
              Stop wasting time on manual product research. Use <strong>ACBuySpreadsheet</strong> to organize, track, and optimize your entire sourcing workflow in one structured system.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
              >
                Access ACBuySpreadsheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line"></i>
                </span>
              </a>
              <Link
                to="/blog/acbuyspreadsheet-product-sourcing-guide"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border border-white/50 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 cursor-pointer"
              >
                Read the Guide
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pb-10 md:pb-14">
        <p className="text-white/30 font-heading text-[clamp(3rem,8vw,10rem)] font-black leading-none text-center tracking-tighter select-none">
          ORGANIZE. SOURCE. SCALE.
        </p>
      </div>
    </section>
  );
}